// Provides a means of passing configuration data to the client.
// This is separated from Hudl.data to indicate the nature of the values
'use strict';

var embed = require('./embedded-data');
var config;

module.exports = {
  get: function(key) {
    // very simple currently
    config = config || (embed.config || {});
    return config[key];
  },
};
